<template>
  <el-dialog
    width="50%"
    title="应收帐款明细"
    :visible.sync="visible"
    :before-close="beforeClose"
  >
    <el-form id="detailFrom" :model="receDetail" label-width="100px">
      <el-row :gutter="30">
        <el-col :span="12">
          <el-form-item label="日期">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="receDetail.payDate"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="支付类型">
            <el-select
              v-model="receDetail.type"
              placeholder="请选择支付类型"
              style="width: 100%"
              clearable
            >
              <el-option label="转帐" value="0"></el-option>
              <el-option label="票据" value="1"></el-option>
              <el-option label="现金" value="2"></el-option>
              <el-option label="其他" value="3"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="金额">
            <el-input v-model="receDetail.amount"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注">
            <el-input v-model="receDetail.remark"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="beforeClose">取 消</el-button>
      <el-button type="primary" @click="saveDetail">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    receDetail: Object,
  },
  methods: {
    beforeClose() {
      this.$emit("update:visible", false);
    },
    saveDetail() {},
  },
};
</script>

<style scoped>
</style>